export const DeviceDetectionService = {
  isIPad: (): boolean => {
    const isIPadUA = /iPad/.test(navigator.userAgent)
    const platform = (navigator as any).userAgentData?.platform ?? navigator.platform ?? ''
    const isIPadOS = platform === 'MacIntel' && navigator.maxTouchPoints > 1
    return isIPadUA || isIPadOS
  },

  isTouchDevice: (): boolean => {
    return 'ontouchstart' in globalThis || navigator.maxTouchPoints > 0
  },

  isIPadOS: (): boolean => {
    return DeviceDetectionService.isIPad() && DeviceDetectionService.isTouchDevice()
  },

  getDevicePixelRatio: (): number => {
    return globalThis.devicePixelRatio || 1
  },
}
